export default __webpack_public_path__ + "static/media/obstaclecourse-01.60b0a960.svg";